import { IQuery, Topics } from '@zaplify/common';
import { MessageDto } from '../dtos';

export class GetMessageQuery extends IQuery<MessageDto | null> {
    public static override readonly TOPIC = Topics.CAMPAIGNS;
    constructor(readonly messageId: string) {
        super();
    }
}

//
// Get message paths for linkedin extension
//

export interface MessageGenLinkedinExtensionCountsResult {
    dailyLimitExceeded: boolean;
    dailyLimit: number | 'inf';
    count: number;
    remainingMessages: number | 'inf';
}

export interface MessagePathsForLinkedinExtensionResult {
    paths: string[] | null;
    counts: MessageGenLinkedinExtensionCountsResult;
}
export interface MessagePathsForLinkedinExtensionMessage {
    sendTimeString: string;
    text: string;
    senderName: string;
    senderProfileUrl: string;
    senderId: string;
    isMe: boolean;
    reactions?: Array<{
        type: string;
        count: number;
    }>[];
}

export interface MessagePathsForLinkedinExtensionPayload {
    prospectId?: string;
    userId: string;
    organizationId: string;
    messages: MessagePathsForLinkedinExtensionMessage[];
}

export class GetMessagePathsForLinkedinExtensionQuery extends IQuery<MessagePathsForLinkedinExtensionResult> {
    constructor(public readonly payload: MessagePathsForLinkedinExtensionPayload) {
        super();
    }
}

export class GetMessageGenLinkedinExtensionCountsQuery extends IQuery<MessageGenLinkedinExtensionCountsResult> {
    constructor(public readonly payload: { userId: string; organizationId: string }) {
        super();
    }
}
